var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import { Typography } from "../Typography";

// PRE-DEFINED TYPOGRAPHY STYLES
// Remeber to end the props with {...props} so they can be overwritten

export var H1 = React.forwardRef(function (props, ref) {
  return React.createElement(
    Typography,
    _extends({
      ref: ref,
      $as: "h1",
      extraBold: true,
      size: [2.5, 3.25, 4],
      color: "primaryDark",
      gutterBottom: true
    }, props),
    props.children
  );
});

export var H2 = React.forwardRef(function (props, ref) {
  return React.createElement(
    Typography,
    _extends({
      ref: ref,
      $as: "h2",
      extraBold: true,
      size: [2, 2, 3],
      color: "primaryDark",
      gutterBottom: true
    }, props),
    props.children
  );
});

export var H3 = React.forwardRef(function (props, ref) {
  return React.createElement(
    Typography,
    _extends({
      ref: ref,
      $as: "h3",
      size: [1.25, 1.25, 1.5],
      color: "primaryDark",
      bold: true,
      gutterBottom: true
    }, props),
    props.children
  );
});